var _path, _g, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStretchedPlay = function SvgStretchedPlay(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 70,
    viewBox: "0 0 80 70",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3886_3804)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3886_3804",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 70
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 0H0V69.7872H80V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3886_3804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.9645 32.2364C79.2598 12.5613 66.0119 1.60261 46.5137 0.252974C22.9864 -1.38486 0.911335 8.51244 0.035734 34.2679C-0.320201 44.6643 2.10728 55.9604 10.7351 62.7367C18.6227 68.9366 29.379 69.8012 39.0747 69.7801C63.3068 69.7379 80.9256 57.8373 79.9645 32.2294",
    fill: "#EBF3F4",
    fillOpacity: 0.9
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0002 51.6668C49.2049 51.6668 56.6668 44.2049 56.6668 35.0002C56.6668 25.7954 49.2049 18.3335 40.0002 18.3335C30.7954 18.3335 23.3335 25.7954 23.3335 35.0002C23.3335 44.2049 30.7954 51.6668 40.0002 51.6668Z",
    stroke: "#385F61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6665 28.3335L46.6665 35.0002L36.6665 41.6668V28.3335Z",
    stroke: "#385F61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3886_3804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 69.7872,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStretchedPlay);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI3MCIgdmlld0JveD0iMCAwIDgwIDcwIiBmaWxsPSJub25lIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM4ODZfMzgwNCkiPgo8bWFzayBpZD0ibWFzazBfMzg4Nl8zODA0IiBzdHlsZT0ibWFzay10eXBlOmx1bWluYW5jZSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjgwIiBoZWlnaHQ9IjcwIj4KPHBhdGggZD0iTTgwIDBIMFY2OS43ODcySDgwVjBaIiBmaWxsPSJ3aGl0ZSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMzg4Nl8zODA0KSI+CjxwYXRoIGQ9Ik03OS45NjQ1IDMyLjIzNjRDNzkuMjU5OCAxMi41NjEzIDY2LjAxMTkgMS42MDI2MSA0Ni41MTM3IDAuMjUyOTc0QzIyLjk4NjQgLTEuMzg0ODYgMC45MTEzMzUgOC41MTI0NCAwLjAzNTczNCAzNC4yNjc5Qy0wLjMyMDIwMSA0NC42NjQzIDIuMTA3MjggNTUuOTYwNCAxMC43MzUxIDYyLjczNjdDMTguNjIyNyA2OC45MzY2IDI5LjM3OSA2OS44MDEyIDM5LjA3NDcgNjkuNzgwMUM2My4zMDY4IDY5LjczNzkgODAuOTI1NiA1Ny44MzczIDc5Ljk2NDUgMzIuMjI5NCIgZmlsbD0iI0VCRjNGNCIgZmlsbC1vcGFjaXR5PSIwLjkiLz4KPC9nPgo8cGF0aCBkPSJNNDAuMDAwMiA1MS42NjY4QzQ5LjIwNDkgNTEuNjY2OCA1Ni42NjY4IDQ0LjIwNDkgNTYuNjY2OCAzNS4wMDAyQzU2LjY2NjggMjUuNzk1NCA0OS4yMDQ5IDE4LjMzMzUgNDAuMDAwMiAxOC4zMzM1QzMwLjc5NTQgMTguMzMzNSAyMy4zMzM1IDI1Ljc5NTQgMjMuMzMzNSAzNS4wMDAyQzIzLjMzMzUgNDQuMjA0OSAzMC43OTU0IDUxLjY2NjggNDAuMDAwMiA1MS42NjY4WiIgc3Ryb2tlPSIjMzg1RjYxIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMzYuNjY2NSAyOC4zMzM1TDQ2LjY2NjUgMzUuMDAwMkwzNi42NjY1IDQxLjY2NjhWMjguMzMzNVoiIHN0cm9rZT0iIzM4NUY2MSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8zODg2XzM4MDQiPgo8cmVjdCB3aWR0aD0iODAiIGhlaWdodD0iNjkuNzg3MiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4=";